export default __webpack_public_path__ + "static/media/indogo-screenshot-02.1136ce95.png";